import { MainInner } from "@/styles/global";
import { Paragraph, h2 } from "@/styles/typography";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const Inner = styled(MainInner)<{ $mediaPosition: string; $bgColor: string }>`
  flex-direction: column;
  gap: 24px;
  align-items: center;
  justify-content: center;
  background-color: ${({ $bgColor }) => $bgColor};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    gap: 40px;

    flex-direction: ${({ $mediaPosition }) =>
      $mediaPosition === "left" ? "row" : "row-reverse"};
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    width: 45%;
  }
`;

const Image = styled(GatsbyImage)`
  aspect-ratio: 5/4;

  img {
    border-radius: 4px;
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    width: 55%;
  }
`;

const Title = styled(h2)``;

const Text = styled(Paragraph)``;

const BtnWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const S = {
  Inner,
  ContentWrapper,
  Image,
  Title,
  Text,
  BtnWrapper,
};

export default S;
